export function casesSlider() {
    const $slider = $(".cases-slider");
    $slider.slick({
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/casesSlider.js